//引入安装的signalr包<br>import * as signalR from '@aspnet/signalr'
import variables from "@/service/variables";
//import router from "../router";
import * as signalR from '@microsoft/signalr'

const signal = new signalR.HubConnectionBuilder()//服务器地址
   /*  .withUrl(variables.SIGNALR_URL +"/chatHub", )
    .build() */


    .withUrl(variables.SIGNALR_URL +"/ChatHub", {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => sessionStorage.getItem("vip_token")
    })
    .build()
   
   /* signal.start().then(function () {
        console.log("Hub 連線完成");
    }).catch(function (err) {
        alert('連線錯誤: ' + err.toString());
    }); */


    signal.on('SendAll', (res) => {
      console.log(res, '收到消息')
    })
  
    signal.on('SendCustomUserMessage', (res) => {
      console.log(res, '收到消息')
    })
    
    signal.on('SendLogoutMessage', (res) => {
      console.log(res, '收到SendLogoutMessage消息')
     })

    signal.onclose((err)=>{
      console.log("连接已经断开 执行函数onclose",err)
    })


    signal.on("UpdContent", function (msg) {
      console.log(msg)
    });

    // 更新連線 ID 列表事件
    signal.on("UpdList", function (jsonList) {
        var list = JSON.parse(jsonList);  
       
        for(let i=0; i<list.length; i++)
        {
          console.log(list[i])
           // $("#IDList").append($("<li></li>").attr("class", "list-group-item").text(list[i]));
        }
      });

    // 更新用戶個人連線 ID 事件
    signal.on("UpdSelfID", function (id) {
        //$('#SelfID').html(id);
         console.log(id)
    });



 
    export default {
        signal
      }